import { render, staticRenderFns } from "./QualityPredictionCard.vue?vue&type=template&id=c12fb75c&scoped=true"
import script from "./QualityPredictionCard.vue?vue&type=script&lang=js"
export * from "./QualityPredictionCard.vue?vue&type=script&lang=js"
import style0 from "./QualityPredictionCard.vue?vue&type=style&index=0&id=c12fb75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12fb75c",
  null
  
)

export default component.exports